// extracted by mini-css-extract-plugin
module.exports = {"description_sa_tool__list":"styles_description_sa_tool__list__zF1m5"};